
$(document).ready(function () {
	$('.js-image-carousel').each(function () {
		var slickInduvidual = $(this);
		if (slickInduvidual.length) {
			slickInduvidual.slick({
				dots: true,
				fade: true,
				adaptiveHeight: true, 
				slidesToShow: 1,
				slide: '.image-carousel-item',
				nextArrow: '<span class="fal fa-long-arrow-right"></span>',
				prevArrow: '<span class="fal fa-long-arrow-left"></span>',
				appendArrows: $(this).find('.image-carousel-controls'),
                appendDots: $(this).find('.image-carousel-dots'),
                autoplay: true,
                autoplaySpeed: 8000,
                lazyLoad: 'ondemand',
			});
		}
    });

    if ($('.desktop-row .watchlist-item').length > 3) {
        $('.movie-poster-carousel').slick({
            slidesToShow: 4,
            arrows: true,
            centerMode: false,
            prevArrow: $('.l-arrow'),
            nextArrow: $('.r-arrow'),
            variableWidth: true,
            infinite: false,
            swipeToSlide: true,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });
    }
}); 


$('.js-image-carousel').on('lazyLoaded', function(evt, slick, $img) {

    $img
        // Find the parent <picture> tag of img
        .closest('picture')
        // Find <source> tags with data-lazy-srcset attribute
        .find('source[data-lazy-srcset]')
        // Copy data-lazy-srcset to srcset
        .each(function (i, source) {
            $source = $(source);
            $source.attr('srcset', $source.data('lazy-srcset'));
        }); 

        $('.js-image-carousel').slick("resize");
        //setTimeout($('.js-image-carousel').slick("resize"), 5000);
});
